// Adjust Redo protection checkbox colors to match dark theme
(function(){
  const COLOR = '#ffffff';
  function restyle(el){
    try {
      if(!el.shadowRoot) return;
      // Inject (or update) our own style block inside the shadow root for persistent override
      let style = el.shadowRoot.querySelector('style[data-redo-override]');
      if(!style){
        style = document.createElement('style');
        style.dataset.redoOverride = 'true';
        el.shadowRoot.appendChild(style);
      }
      style.textContent = `:host, [data-target="checkbox-root"], [data-target="checkbox-label"], [data-target="checkbox-info"] { color: ${COLOR} !important; }
      [data-target="checkbox-label"], [data-target="checkbox-info"] { opacity: .92; }`;
      // Optional: expose a CSS var for future theming
      el.style.setProperty('--redo-theme-text-color', COLOR);
    } catch(e){ /* ignore */ }
  }
  function scan(){ document.querySelectorAll('redo-shopify-checkbox').forEach(restyle); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  new MutationObserver(muts=>{
    let found=false; for(const m of muts){ for(const n of m.addedNodes){ if(n.nodeType===1 && n.matches && n.matches('redo-shopify-checkbox')) { found=true; } } }
    if(found) scan();
  }).observe(document.documentElement,{childList:true, subtree:true});
})();

// Restyle the Redo Back-in-Stock "Notify me when available" button to match theme tokens.
// CSS vars like --btn-bg-color are set on .color-scheme-* wrappers, so we resolve them
// from the nearest ancestor and inject literal values into the shadow DOM.
(function(){
  function getComputedVar(el, varName, fallback) {
    var val = window.getComputedStyle(el).getPropertyValue(varName).trim();
    return val || fallback;
  }

  function restyleBIS(el){
    try {
      if(!el.shadowRoot) return;

      // Walk up to find the nearest element with a color-scheme var defined
      var schemeAncestor = el.closest('[class*="color-scheme"]') ||
                           document.querySelector('[class*="color-scheme"]') ||
                           document.body;

      // Read the space-separated rgb values (e.g. "28 28 28") and wrap in rgb()
      var bgRaw    = getComputedVar(schemeAncestor, '--btn-bg-color', '');
      var textRaw  = getComputedVar(schemeAncestor, '--btn-text-color', '');
      var radius   = getComputedVar(schemeAncestor, '--btn-border-radius', '0px');
      var bWidth   = getComputedVar(schemeAncestor, '--btn-border-width', '2px');
      var txform   = getComputedVar(schemeAncestor, '--btn-text-transform', 'none');

      var bg   = bgRaw   ? 'rgb(' + bgRaw + ')'   : '#1a1a1a';
      var text = textRaw ? 'rgb(' + textRaw + ')' : '#ffffff';

      var style = el.shadowRoot.querySelector('style[data-redo-bis-override]');
      if(!style){
        style = document.createElement('style');
        style.dataset.redoBisOverride = 'true';
        el.shadowRoot.appendChild(style);
      }
      // Override Redo's inline styles with !important; match .btn + .btn--primary rules
      style.textContent = [
        'button[data-theme] {',
        '  background-color: #00e19c !important;',
        '  background-image: linear-gradient(105deg, #00ffbf 0%, #00ff88 40%, #00e19c 100%) !important;',
        '  background-size: 100% 100% !important;',
        '  color: #0f1823 !important;',
        '  border: 0 !important;',
        '  border-radius: 15px !important;',
        '  font-family: Inter, "Arial Black", Arial, sans-serif !important;',
        '  font-weight: 800 !important;',
        '  font-size: 0.88em !important;',
        '  letter-spacing: .06em !important;',
        '  text-transform: uppercase !important;',
        '  padding: 12px 26px !important;',
        '  width: 100% !important;',
        '  position: relative !important;',
        '  overflow: hidden !important;',
        '  outline: 2px solid transparent !important;',
        '  outline-offset: 2px !important;',
        '  box-shadow: 0 6px 22px -6px #00c3ff8c, 0 0 0 1px #ffffff14 !important;',
        '  transition: background-color .35s ease, box-shadow .4s ease, transform .25s ease-out !important;',
        '  cursor: pointer !important;',
        '}',
        'button[data-theme]:hover, button[data-theme]:focus-visible {',
        '  background-color: #0f1823 !important;',
        '  background-image: none !important;',
        '  color: #fff !important;',
        '  transform: translateY(-3px) !important;',
        '  box-shadow: 0 0 0 2px #00e19c, 0 12px 34px -12px #00e19c8c !important;',
        '}'
      ].join('\n');
    } catch(e){ /* ignore */ }
  }

  function scanBIS(){ document.querySelectorAll('redo-back-in-stock-container-element').forEach(restyleBIS); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', scanBIS); } else { scanBIS(); }
  new MutationObserver(function(muts){
    var found=false;
    for(var i=0;i<muts.length;i++){
      for(var j=0;j<muts[i].addedNodes.length;j++){
        var n=muts[i].addedNodes[j];
        if(n.nodeType===1 && n.matches && n.matches('redo-back-in-stock-container-element')) found=true;
      }
    }
    if(found) scanBIS();
  }).observe(document.documentElement,{childList:true, subtree:true});
})();
